import { render } from "./que2.vue?vue&type=template&id=058183e1"
import script from "./que2.vue?vue&type=script&lang=js"
export * from "./que2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__